// PROPERTY DETAILS
// ------------------------------------------------------

export const PICKABLE_PROPERTIES_AMENITIES = [
  {
    label: "Bicycle Parking",
    value: "bicycle-parking",
    type: "checkbox",
  },
  {
    label: "Business Center",
    value: "business-center",
    type: "checkbox",
  },
  {
    label: "Clubhouse",
    value: "clubhouse",
    type: "checkbox",
  },
  {
    label: "Controlled Access",
    value: "controlled-access",
    type: "checkbox",
  },
  {
    label: "Dog Park",
    value: "dog-park",
    type: "checkbox",
  },
  {
    label: "Elevator",
    value: "elevator",
    type: "checkbox",
  },
  {
    label: "EV Charging",
    value: "ev-charging",
    type: "checkbox",
  },
  {
    label: "Fitness Center",
    value: "fitness-center",
    type: "checkbox",
  },
  {
    label: "Near Parks",
    value: "near-parks",
    type: "checkbox",
  },
  {
    label: "Off-Street Parking",
    value: "off-street-parking",
    type: "checkbox",
  },
  {
    label: "On-Site Laundry",
    value: "on-site-laundry",
    type: "checkbox",
  },
  {
    label: "Playground",
    value: "playground",
    type: "checkbox",
  },
  {
    label: "Pool",
    value: "pool",
    type: "checkbox",
  },
  {
    label: "Storage Units",
    value: "storage-units",
    type: "checkbox",
  },
  {
    label: "Waterfront",
    value: "waterfront",
    type: "checkbox",
  },
];
